import React from 'react';
import { useHistory } from 'react-router-dom';
import { Result, Button } from 'antd';
import { LayoutPage } from 'components/layouts';

import './style.css';

const E404 = () => {
  const history = useHistory();

  return (
    <LayoutPage className="error-page">
      <LayoutPage.Container className="wrapper">
        <Result
          style={{ width: '100%' }}
          status="404"
          title="404"
          subTitle="Sorry, the page you visited does not exist."
          extra={
            <Button
              type="primary"
              onClick={() => {
                history.push('/');
              }}
            >
              Back Home
            </Button>
          }
        />
      </LayoutPage.Container>
    </LayoutPage>
  );
};

E404.propTypes = {};

export default E404;
